import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCallCenterAgents, CallCenterAgent } from '../../thunks/CallCenterThunks/callCenterAgents';

interface CallCenterAgentsState {
  items: CallCenterAgent[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: CallCenterAgentsState = {
  items: [],
  status: 'idle',
  error: null,
};

const callCenterAgentsSlice = createSlice({
  name: 'callCenterAgents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCallCenterAgents.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchCallCenterAgents.fulfilled, (state, action: PayloadAction<CallCenterAgent[]>) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchCallCenterAgents.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message ?? 'Something went wrong';
      });
  },
});

export default callCenterAgentsSlice.reducer;
